// 时间格式转换
//	将时间戳转换为时间
export function formatDateTime1(inputTime) {
  var date = new Date(inputTime);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  var d = date.getDate();
  d = d < 10 ? '0' + d : d;
  return y + '年' + m + '月' + d + '日';
}

export function formatDateTime2(inputTime) {
  var date = new Date(inputTime);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  var d = date.getDate();
  d = d < 10 ? '0' + d : d;
  return y + '-' + m + '-' + d;
}

//	将时间戳转换为时间
export function formatDateTime(inputTime) {
  var date = new Date(inputTime);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  var d = date.getDate();
  d = d < 10 ? '0' + d : d;
  var h = date.getHours();
  h = h < 10 ? '0' + h : h;
  var minute = date.getMinutes();
  var second = date.getSeconds();
  minute = minute < 10 ? '0' + minute : minute;
  second = second < 10 ? '0' + second : second;
  return y + '-' + m + '-' + d + ' ' + h + ':' + minute;
}

//	将时间戳转换为时间
export function formatDateTime3(inputTime) {
  var date = new Date(inputTime);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  var d = date.getDate();
  d = d < 10 ? '0' + d : d;
  var h = date.getHours();
  h = h < 10 ? '0' + h : h;
  var minute = date.getMinutes();
  var second = date.getSeconds();
  minute = minute < 10 ? '0' + minute : minute;
  second = second < 10 ? '0' + second : second;
  return h + ':' + minute;
}

var selGkId = ''; // 被选中的排口Id
var keyGkId = []; // 被选中的排口key
var comName = ''; // 公司名字
var gkName = ''; // 排口的名字
// 整理页面树形结构
export function createTree(list, comids) {
  const _warrSite_ids = []; // 用于记录传入公司id时 记录所有报警排口的id集合

  let childerList = []; // 子项数据
  // 处理得到数据 添加上树菜单需要的字段
  for (let i = 0; i < list.length; i++) {
    // 判断有没有子项
    if (list[i].companylist.length > 0) {
      childerList = twoLevelTree(list[i].companylist, i, comids, '1' + list[i].street_id);
    }

    // 添加1级数菜单 【街道】
    list[i].title = list[i].street_name; // 新添title字段 树菜单显示标题
    list[i].icon = 'icon iconfont icon-quyu'; // 新添icon字段 街道图标
    list[i].level = 1; // 添加层级 当前第1层 用于点击事件判断用
    list[i].keyID = '1' + list[i].street_id; // 添加一个唯一ID 用于展开使用 ；  '1'+ 是为了 1层、2层、3层没有相同的ID
    list[i].childrens = childerList; // 添加用于树菜单的childrens子级名
  }
  // 返回 整理好的列表，被选中的key
  return {
    list: list,
    selGkId: selGkId,
    keyGkId: keyGkId,
    comName: comName,
    gkName: gkName,
  };

  // this.treeData = list; // 处理好的list赋值树菜单渲染
}

// 创建第二层树
function twoLevelTree(list, num, comids, streeId) {
  // 记录子级
  let childerList = [];
  // 判断是否有子级
  for (let i = 0; i < list.length; i++) {
    if (list[i].siteid_list.length > 0) {
      // 如果传公司id
      if (comids) {
        // -1 不是被选中的公司
        let showCom = -1;
        // 比较公司id
        if (comids == list[i].company_id) {
          keyGkId = [];
          showCom = 1;
          comName = list[i].company_name;
          keyGkId.push('2' + list[i].company_id);
        }

        childerList = threeLevelTree(list[i].siteid_list, num, i, showCom, list[i].company_name);
      } else {
        // 记录公司名

        if (num == 0 && i == 0) {
          keyGkId = [];
          comName = list[i].company_name;
          keyGkId.push('2' + list[i].company_id);
        }

        childerList = threeLevelTree(list[i].siteid_list, num, i, false, list[i].company_name);
      }
    }
    list[i].title = list[i].company_name; // 新添title字段 树菜单显示标题
    list[i].icon = 'icon iconfont icon-jiudian'; // 新添icon字段 企业图标
    list[i].level = 2; // 添加层级 当前第1层 用于点击事件判断用
    list[i].keyID = '2' + list[i].company_id; // 添加一个唯一ID 用于展开使用 ；  '2'+ 是为了  1层、2层、3层没有相同的ID
    list[i].childrens = childerList; // 添加用于树菜单的childrens子级名
  }

  return list;
}

// 创建第三层树
function threeLevelTree(list, num, chNum, isCom, parent) {
  // 记录子级

  for (let i = 0; i < list.length; i++) {
    list[i].title = list[i].gkSite_name; // 新添title字段 树菜单显示标题
    list[i].parentName = parent + ' - ' + list[i].gkSite_name;
    list[i].icon = 'icon iconfont icon-youyanji1'; // 新添icon字段 排口图标
    list[i].level = 3; // 添加层级 当前第1层 用于点击事件判断用
    list[i].keyID = '3' + list[i].gkSite_id; // 添加一个唯一ID 用于展开使用；  '3'+ 是为了  1层、2层、3层没有相同的ID
    // 有公司id
    if (isCom) {
      if (isCom == 1) {
        selGkId = list[i].gkSite_id;
        keyGkId.push(list[i].keyID);
        gkName = list[i].gkSite_name;
      }
    } else {
      // 没有公司id
      if (num == 0 && chNum == 0 && i == 0) {
        selGkId = list[i].gkSite_id;
        keyGkId.push(list[i].keyID);
        gkName = list[i].gkSite_name;
      }
    }
  }

  return list;
}

// 自定义树形内容
export function customContent(data, node, h) {
  if (
    data.streetStatus === 1 ||
    data.streetStatus === 2 ||
    data.warnStatus === 1 ||
    data.status === 1 ||
    data.status === 2
  ) {
    return (
      <span style="font-size: 16px;color:red;">
        {' '}
        <i class={data.icon}> </i> <span style="padding-left: 4px;"> {node.label} </span>{' '}
      </span>
    );
  } else {
    return (
      <span style="font-size: 16px">
        {' '}
        <i class={data.icon}> </i> <span style="padding-left: 4px;"> {node.label} </span>{' '}
      </span>
    );
  }
}

// 报警表头
export function createTitle(page, size) {
  return [
    {
      type: 'index',
      title: '序号',
      align: 'center',
      minWidth: 90,
      indexMethod: row => {
        return row._index + 1 + page * size - size;
      },
    },
    {
      title: '监测时间',
      align: 'center',
      minWidth: 150,
      render: (h, params) => {
        // 对比有无对应数据
        let res = params.row.data.find(res => {
          return params.column.title == res.key;
        });
        if (res) {
          return h('div', res.value);
        } else {
          return h('div', '--');
        }
      },
    },
    {
      title: '监测名称',
      align: 'center',
      minWidth: 130,
      render: (h, params) => {
        // 对比有无对应数据
        let res = params.row.data.find(res => {
          return params.column.title == res.key;
        });

        if (res) {
          return h('div', res.value);
        } else {
          return h('div', '--');
        }
      },
    },
    {
      title: '编码',
      align: 'center',
      minWidth: 130,
      render: (h, params) => {
        // 对比有无对应数据
        let res = params.row.data.find(res => {
          return params.column.title == res.key;
        });
        if (res) {
          return h('div', res.value);
        } else {
          return h('div', '--');
        }
      },
    },
    {
      title: '当前值',
      align: 'center',
      minWidth: 130,
      render: (h, params) => {
        // 对比有无对应数据
        let res = params.row.data.find(res => {
          return params.column.title == res.key;
        });
        if (res) {
          return h(
            'div',
            {
              class: 'demo-table-info-cell-value',
            },
            res.value,
          );
        } else {
          return h('div', '--');
        }
      },
    },
    {
      title: '状态',
      align: 'center',
      minWidth: 130,
      render: (h, params) => {
        // 对比有无对应数据
        let res = params.row.data.find(res => {
          return params.column.title == res.key;
        });
        if (res) {
          return h(
            'div',
            {
              class: 'demo-table-info-cell-value',
            },
            res.value,
          );
        } else {
          return h('div', '--');
        }
      },
    },
  ];
}

// 获取表头
export function getTableTitle(list, page, size, num, time) {
  var tableList = [];
  if (num == 1) {
    tableList.push({
      type: 'index',
      title: '日期',
      align: 'center',
      minWidth: 180,
      indexMethod: row => {
        let timeIndex = row._index;
        if (row._index < 10) {
          timeIndex = '0' + row._index;
        }

        return time + ' ' + timeIndex + '点';
      },
    });
  } else {
    tableList.push({
      type: 'index',
      title: '序号',
      align: 'center',
      minWidth: 90,
      indexMethod: row => {
        return row._index + 1 + page * size - size;
      },
    });
  }

  for (var i = 0; i < list.length; i++) {
    tableList.push({
      title: list[i].cnName,
      align: 'center',
      minWidth: 145,
      render: (h, params) => {
        let _class = '';
        let _class1 = '';
        let opt = '';
        let statuflag = '';
        // 对比有无对应数据
        const res = params.row.lineData.find(values => {
          return values.cnName == params.column.title;
        });
        // 有对应数据
        if (res.hasData) {
          let _class = '';
          let _class1 = '';
          // warnStatus报警状态：1低于，2无报警，3：高于
          if (res.warnStatus == 1) {
            _class = 'demo-table-info-cell-value';
            _class1 = 'icon iconfont icon-down demo-table-info-cell-value';
            return h('div', res.value);
          } else if (res.warnStatus == 3) {
            _class = 'demo-table-info-cell-value';
            _class1 = 'icon iconfont icon-up-copy demo-table-info-cell-value';
          }

          return h('div', [
            h(
              'span',
              {
                class: _class,
              },
              res.value,
            ),
            h('i', {
              class: _class1,
            }),
          ]);
        } else {
          // 没有数据
          return h('div', '--');
        }
      },
    });
  }

  return tableList;
}

// 下载excl文件
export function downfile(content, filename) {
  // 创建隐藏的可下载链接
  var eleLink = document.createElement('a');
  eleLink.download = filename;
  eleLink.target = '_blank';
  eleLink.style.display = 'none';
  // 字符内容转变成blob地址

  //不转 直接下载cont链接
  eleLink.href = content;
  // 触发点击
  document.body.appendChild(eleLink);
  eleLink.click();
  // 然后移除
  document.body.removeChild(eleLink);
}
